import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

const APPSFLYER_ONELINK_BADGE_IOS = 'https://bridebook.onelink.me/q51D/badge';
const APPSFLYER_ONELINK_BADGE_ANDROID = 'https://bridebook.onelink.me/q51D/badgeandroid';
const QR_CODE_IMG_URL = `${IMAGES_BASE_URL}/assets/appstore/app-download-qr-code.png`;

type BadgesInfo = {
  apple: {
    img: string;
    url: string;
  };
  google: {
    img: string;
    url: string;
  };
  code: {
    img: string;
  };
};

// https://tools.applemediaservices.com/app/1200853011
const localeToAppleImg: Record<'en' | string, string> = {
  de: `${IMAGES_BASE_URL}/assets/appstore/de-badge-appstore.svg`,
  en: `${IMAGES_BASE_URL}/assets/appstore/appstore_v2.svg`,
  fr: `${IMAGES_BASE_URL}/assets/appstore/fr-badge-appstore.svg`,
};

const getAppleImg = (lang: Market['language']) => localeToAppleImg[lang] || localeToAppleImg.en;

// https://play.google.com/intl/en_us/badges/
const langToGoogleImg: Record<'en' | string, string> = {
  de: `${IMAGES_BASE_URL}/assets/google-play/google-play-badge_de.png`,
  en: `${IMAGES_BASE_URL}/assets/google-play/google-play-badge_en.png`,
  fr: `${IMAGES_BASE_URL}/assets/google-play/google-play-badge_fr.png`,
};

const getGoogleImg = (lang: Market['language']) => langToGoogleImg[lang] || langToGoogleImg.en;

const getBadgesInfo = (market: Market): BadgesInfo => ({
  apple: {
    img: getAppleImg(market.language),
    url: APPSFLYER_ONELINK_BADGE_IOS,
  },
  google: {
    img: getGoogleImg(market.language),
    url: APPSFLYER_ONELINK_BADGE_ANDROID,
  },
  code: {
    img: QR_CODE_IMG_URL,
  },
});

export { getBadgesInfo };
